// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3tpWC","row":"ProcedureTreatmentSummary_row__35LF_"};